module.exports = __webpack_public_path__ + "img/03.af8f86ee.png";